import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { SavedPin } from '@models/teranet';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { SalePinState } from '@state/sale_pins';
import { Observable, Subject } from 'rxjs';
import { ICON } from '@core/util/icon';
import { Select } from '@ngxs/store';

@Component({
	selector: 'app-sync',
	templateUrl: './sync.component.html',
	styleUrls: ['./sync.component.scss'],
	standalone: false,
})
export class TeranetStepperSyncComponent {
	@ViewSelectSnapshot(SalePinState.getPrimary) primary: SavedPin[];
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(SalePinState.hasPins) hasPins$: Observable<boolean>;
	@ViewChild('syncForm') form: NgForm;

	ICON = ICON;
	public submitSubject: Subject<void> = new Subject<void>();
	public error: string;

	constructor(private matterDispatch: MatterDispatch) {}

	onSubmit = (): void => {
		this.submitSubject.next();
	};

	setError(_error: string): void {
		this.error = _error;
	}

	back = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.SEARCH,
		);
	};

	onSyncSuccess() {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.INSTRUMENTS,
		);
	}
}
